import React, { useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Grid from "@mui/material/Grid";
import Summary from "components/EmployeeTimeLogs/FieldRepTimeLogs/Summary";
import Performance from "components/EmployeeTimeLogs/FieldRepTimeLogs/Performance";
import CaseMileage from "components/EmployeeTimeLogs/FieldRepTimeLogs/CaseMileage.tsx";
import MacCard from "components/User/Mac/MacCard";
import FieldRepContactInfo from "components/EmployeeTimeLogs/FieldRepTimeLogs/FieldRepContactInfo";
import { getPaySummary } from "actions/homeowner/fieldReps";
import { clone } from "lodash";
import { dateToStringYy } from "components/Shared/Formatters";
import AdminTimeLog from "components/Shared/AdminTimeLog";
import { ALLOWEDITDATEFORFRTIMELOG, EMPLOYEENOTES_VIEW } from "typeConstants/rights";
import { userHasRight } from "selectors/rights";
import EmployeeTEAM from "components/Employee/EmployeeTEAM";
import CaseProfile from "containers/Homeowner/CaseProfile/CaseProfile";

const FieldRepTimeLogDetails = ({
  selectedPayPeriod,
  selectedEmployee,
  getPaySummary,
  isFetchingInspectorPayPeriodSummary,
  inspectorPayPeriodSummary,
  canEditAdminTimeLog,
  canViewNotes,
}) => {
  const [selectedControlNumber, setSelectedControlNumber] = useState(null);

  const getRows = paySummary => {
    const { payPeriodCases, totalMac, totalCaseCost, totalMileage, totalHours } = paySummary;
    let rows = clone(payPeriodCases);
    rows.map(row => row.submittedDate = dateToStringYy(row.submittedDate));
    if (rows.length > 0) {
      rows.push({
        submittedDate: "Total",
        mileage: totalMileage,
        minutes: totalHours,
        mac: `$${totalMac}`,
        caseCost: `$${totalCaseCost}`,
      });
    }
    return rows;
  };

  const onControlNumberSelected = controlNumber => {
    if (controlNumber !== selectedControlNumber) setSelectedControlNumber(controlNumber);
  };

  return (
    <>
      <Grid item xs={12} className="fr-timelogs-right-pane">
        <FieldRepContactInfo
          inspectorNumber={selectedEmployee.number}
        />
        <Summary
          employeeName={selectedEmployee.name}
          inspectorNumber={selectedEmployee.number}
          payPeriodId={selectedPayPeriod.id}
        />
        <Performance
          inspectorNumber={selectedEmployee.number}
          payPeriodId={selectedPayPeriod.id}
          payPeriodClosed={selectedPayPeriod.closedDate}
          onControlNumberSelected={onControlNumberSelected}
        />
        <CaseMileage
          inspectorNumber={selectedEmployee.number}
          payPeriodId={selectedPayPeriod.id}
          payPeriodClosed={selectedPayPeriod.closedDate}
          onControlNumberSelected={onControlNumberSelected}
        />
        <MacCard
          // Key this element so it reloads when its data changes since it wasnt built with prop changing in mind
          key={`MacCard-${selectedEmployee.number}-${selectedPayPeriod.id}`}
          payPeriod={selectedPayPeriod}
          hidePayPeriodSelection
          employeeID={selectedEmployee.number}
          getPaySummary={getPaySummary}
          isFetchingPayPeriodSummary={isFetchingInspectorPayPeriodSummary}
          paySummary={inspectorPayPeriodSummary}
          getRows={getRows}
          FRMac
        />
        <AdminTimeLog
          // Key this element so it reloads when its data changes
          key={`AdminTimeLog-${selectedEmployee.number}-${selectedPayPeriod.id}`}
          inspectorNumber={selectedEmployee.number}
          payPeriodId={selectedPayPeriod.id}
          canAddAndEdit={canEditAdminTimeLog}
        />
        { canViewNotes &&
          <EmployeeTEAM 
            key={`EmployeeTeam-${selectedEmployee.number}}`}
            internetUserId={selectedEmployee.internetUserId}
          />
        }
      </Grid>
      {selectedControlNumber &&
        <Grid item xs={12} style={{ marginTop: 0, paddingTop: 0 }}>
          <CaseProfile
            controlNumber={selectedControlNumber}
            verticalDisplay={true}
          />
        </Grid>
      }
    </>
  );
};

FieldRepTimeLogDetails.propTypes = {
  selectedPayPeriod: PropTypes.object,
  selectedEmployee: PropTypes.object,
  // Dispatch and State props
  getPaySummary: PropTypes.func,
  isFetchingInspectorPayPeriodSummary: PropTypes.bool,
  inspectorPayPeriodSummary: PropTypes.array,
  canEditAdminTimeLog: PropTypes.bool,
  canViewNotes: PropTypes.bool,
};

const mapStateToProps = state => {
  return {
    isFetchingInspectorPayPeriodSummary: state.assignment.isFetchingInspectorPayPeriodSummary,
    inspectorPayPeriodSummary: state.assignment.inspectorPayPeriodSummary,
    canEditAdminTimeLog: userHasRight(ALLOWEDITDATEFORFRTIMELOG)(state),
    canViewNotes: userHasRight(EMPLOYEENOTES_VIEW)(state),
  };
};

const mapDispatchToProps = dispatch => ({
  getPaySummary(inspectorNumber, payPeriodId) {
    dispatch(getPaySummary(inspectorNumber, payPeriodId));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(FieldRepTimeLogDetails);